import { useNavigation } from "@luce/core/adapters/navigation";
import { Divider, ListItem } from "@luce/ui";

import { isUpcomingPlan } from "../lib";
import { usePackageDetailContext } from "../package-detail-context";

interface PackageCancelPlanProps {
  onCancelUpcomingPlan: () => void;
}

export function PackageCancelPlan({ onCancelUpcomingPlan }: PackageCancelPlanProps) {
  const { push } = useNavigation();
  const { packageDetail, isActive } = usePackageDetailContext();

  if (!isActive) return null;

  const onCancelPlan = () => {
    if (isUpcomingPlan(packageDetail.startDate)) {
      onCancelUpcomingPlan();
    } else {
      push(`/profile/packages/${packageDetail.id}/terminate`);
    }
  };

  return (
    <>
      <Divider />
      <ListItem onPress={onCancelPlan} divider={false} tone="destructive">
        <ListItem.LeadingIcon name="XCircle" size={24} weight="fill" />
        <ListItem.Content>
          <ListItem.ContentTitle>Cancel Plan</ListItem.ContentTitle>
        </ListItem.Content>
        <ListItem.TrailingIcon name="CaretRight" size={16} />
      </ListItem>
    </>
  );
}
